<template>
  <div class="footer">
    <!--上底部-->
    <div class="footer_top">
      <div class="w">
        <div>
          <h4>联系我们</h4>
        </div>
        <p>专注互联网先锋技术研发，根据您的需求定制企业专属战略解决方案。</p>
        <div>
          <input type="text" v-model="company_name" placeholder="请输入公司名称" />
          <input type="text" v-model="name" placeholder="请输入姓名" />
          <input type="text" v-model="telephone" placeholder="请输入联系电话" />
          <input type="text" v-model="content" placeholder="请输入想要咨询的业务需求" />
          <button @click="btn_Submit()">确定提交</button>
        </div>
      </div>
    </div>
    <!--下底部-->
    <div class="footer_bottom">
      <div class="w">
        <div class="mod_help">
          <dl>
            <dt style="cursor: pointer" @click="toCustomDev">定制开发</dt>
            <dd>
              <a href="/customDev?id=solution">解决方案</a>
            </dd>
            <dd>
              <a href="/customDev?id=TechnicalStrength">技术实力</a>
            </dd>
            <dd>
              <a href="/customDev?id=zhuanyetuandui">专业团队</a>
            </dd>
            <dd>
              <a href="/customDev?id=kehuanli">客户案例</a>
            </dd>
          </dl>
          <dl>
            <dt style="cursor: pointer" @click="toCustomerCase">客户案例</dt>
            <dd>
              <a href="/customerCase?id=1">企业数字化转型</a>
            </dd>
            <dd>
              <a href="/customerCase?id=2">新零售电商/商贸</a>
            </dd>
            <dd>
              <a href="/customerCase?id=3">文娱演出行业服务</a>
            </dd>
            <dd>
              <a href="/customerCase?id=4">物联网iot</a>
            </dd>
            <dd>
              <a href="/customerCase?id=5">健康医疗服务</a>
            </dd>
            <dd>
              <a href="/customerCase?id=6">生产制造/汽车</a>
            </dd>
            <dd>
              <a href="/customerCase?id=7">机构/金融/地产服务</a>
            </dd>
            <dd>
              <a href="/customerCase?id=8">企业IT服务</a>
            </dd>
          </dl>
          <dl>
            <dt style="cursor: pointer" @click="toAboutUs">关于我们</dt>
            <dd>
              <a href="/aboutUs?id=brief">企业简介</a>
            </dd>
            <dd>
              <a href="/aboutUs?id=company">团队介绍</a>
            </dd>
            <dd>
              <a href="/aboutUs?id=coreExperts">核心专家</a>
            </dd>
            <dd>
              <a href="/aboutUs?id=senseOfWorth">企业价值观</a>
            </dd>
            <dd>
              <a href="/aboutUs?id=partner">合作伙伴</a>
            </dd>
          </dl>

          <div class="erweima">
            <img src="../assets/img/QRcode.jpg">
            <div class="erweima_name">业务咨询</div>
          </div>
          <div class="erweima">
            <img src="../assets/img/gzh.jpg">
            <div class="erweima_name">畅音科技公众号</div>
          </div>


          <ul>
            <li class="lis">联系我们</li>
            <li>咨询热线：<p>+86 13391444013</p> 或 <p>18019462791</p>
            </li>
            <li>联系地址：上海总部：上海市浦东新区张衡路290号3楼<br>&ensp; &ensp; &ensp; &ensp; &ensp;&ensp; &ensp;
              重庆分部：重庆市渝北区星光大道60号金星科技大厦4楼412</li>
            <li>联系邮箱：cs@changyin.sh.cn</li>

          </ul>

        </div>
      </div>
      <!--下底部logo部分-->
      <div class="footer_logo w">
        <img src="../assets/img/SmoothsoundLOGO.png" />
        <p>专注互联网先锋技术研发，根据您的需求定制企业专属战略解决方案。</p>
        <p style="display: inline-block">上海畅音实业有限公司是企业级移动战略服务商，专注于移动互联网先锋技术研发，为企业提供整体移动解决方案，是企业”互联网+”战略最佳拍档。</p>
        <p style="display: inline-block;float: right;"><a href="https://beian.miit.gov.cn/#/Integrated/index" target=“_blank” style="color:#98A3B7">沪ICP备16009957号-1</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  import '@/assets/sass/footer.css'
  import eventBus from "@/assets/js/eventBus"

  import {
    add
  } from '@/api/index'
  export default {
    name: 'footers',
    data() {
      return {
        name: '',
        telephone: '',
        content: '',
        company_name: '',
      }
    },
    mounted() {
      if (this.$route.query.name) {
        window.scrollTo(0, 50000);
      }
    },
    methods: {
      btn_Submit() {
        let _that = this;
        if (this.name == '' || this.telephone == '' || this.content == '') {
          this.$Message.warning('姓名或手机号不能为空', 5);
          return
        } else {
          if (!(/^1[3456789]\d{9}$/.test(this.telephone))) {
            this.$Message.warning('手机号格式不正确', 5);
            return;
          }

        }

        let From = new FormData();
        From.append('name', this.name);
        From.append('telephone', this.telephone)
        From.append('content', this.content)
        From.append('company_name', this.company_name)
        add(From).then((data) => {
          if (data) {
            alert("提交成功");
          } else {
            alert("提交失败");
          }
          this.name = '';
          this.telephone = '';
          this.content = '';
          this.company_name = '';
        }).catch((error) => {

        })
      },
      toCustomDev(){
        eventBus.$emit("header",2)
        this.$router.push('/customDev')
      },
      toCustomerCase(){
        eventBus.$emit("header",3)
        this.$router.push('/customerCase')
      },
      toAboutUs(){
        eventBus.$emit("header",4)
        this.$router.push('/aboutUs')
      },
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/footers.vue